import React, {useState} from 'react'
import { IoChevronDown } from "react-icons/io5";
import './Singleselect.css'

const Singleselect = ({selectedSocVal, placeholder, socialjs}) => {
    const [socialvalue, setSocialvalue] = useState("")
    const [social, setSocial] = useState(false)

    const handleSocialFocus = () =>{
        setSocial(!social)
    }

    const handleValueChange = (e) =>{
        setSocial(true)
        setSocialvalue(e.target.value)
    }
    
    const handleSocialClick = (e, incoming) =>{
        setSocialvalue(incoming.soc)
        setSocial(!social)
        selectedSocVal(incoming.soc)
    }

    var SocialLists = socialjs.filter((filteredItem) => {
        if (filteredItem.name.toLowerCase().includes(socialvalue.toLowerCase())) {
          return filteredItem;
        }
    });
    
  return (
    <div className='single-selectt-container'>
        <input value={socialvalue} onFocus={handleSocialFocus} onChange={handleValueChange}  placeholder={placeholder} id="bnw-firnamee-box"/>
            <IoChevronDown id="chevron-down" onClick={handleSocialFocus}/>
            {social && <div className='bnw-regionn-drpdwn'>{SocialLists.sort((a, b) => a.name > b.name ? 1 : -1).map((item, key) => (
                <span onClick={e => handleSocialClick(e, {soc: item.value})} key={key}>{item.value}</span>
            ))}
            </div>}
    </div>
  )
}

export default Singleselect